import {AbstractFindOneByAttributeService} from './abstractFindOneByAttribute.service';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';


export abstract class AbstractFindOneByIdService<StoredEntity, Entity> extends AbstractFindOneByAttributeService<StoredEntity, Entity> {


    protected constructor(entityCollectionServiceBase: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>) {
        super(entityCollectionServiceBase, dataService);


    }

    protected getAttributeName(): string {
        return 'id';
    }
}
